'use client';
import parse from 'html-react-parser';
import { useAppDispatch, useAppSelector } from 'lib/hooks';
import { RootState } from 'lib/store';
import Link from 'next/link';
import { ReactElement, useState } from 'react';
import { setGatedContentDestination } from 'slices/eligibilitySlice';
import { ContentCardItem } from 'types/content';
import { gatedConditionsCheck } from 'utils/conditionsCheck';

const ContentCard: React.FC<ContentCardItem> = ({
  gatedConditions,
  gatedConditionText,
  gatedContentButtonDestination,
  icon,
  slug,
  title,
}: ContentCardItem): ReactElement => {
  const dispatch = useAppDispatch();

  // I don't think this component is used anymore
  // but for now, you get an eligible, and YOU get an eligible!!
  const completedEligibility = true;

  const { viewedContent } = useAppSelector(
    (state: RootState) => state.navigation
  );

  const [isContentGated] = useState(
    gatedConditionsCheck(gatedConditions, completedEligibility)
  );
  const [isHovering, setIsHovering] = useState(false);

  const setDestination = () => {
    if (isContentGated) {
      dispatch(setGatedContentDestination(slug));
    }
  };

  return (
    <article>
      <Link href={`/${isContentGated ? gatedContentButtonDestination : slug}`}>
        <button
          onClick={() => {
            setDestination();
          }}
        >
          <div
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            <div className="content-thumb">{icon && parse(icon)}</div>
            <div>
              <h3>{parse(title)}</h3>
            </div>

            {viewedContent.includes(slug) && (
              <div className="content-seen-icon"></div>
            )}
            {isContentGated && <div className="content-gated-icon"></div>}
            {isContentGated && isHovering && (
              <div className="gated-overlay">
                <span></span>
                <span>{parse(gatedConditionText)}</span>
              </div>
            )}
          </div>
        </button>
      </Link>
    </article>
  );
};

export default ContentCard;
